import React from 'react';
import OrganizationsTable from '../components/OrganizationsTable';

const Organizations = () => {
  return <OrganizationsTable />;
};

export default Organizations;
